import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import FolderSelector, {DEFAULT_PROJECT_FOLDER_LABEL_TEXT} from 'file-browser/FolderSelector';
import clampEntryName from 'notebook/entry-templates/clampEntryName';
import {
  CreateEntryFromTemplateModalContentsProps,
  renderTagTable,
} from 'notebook/entry-templates/CreateEntryFromTemplateModal/utils';
import SelectTemplateCollectionItemTree from 'notebook/entry-templates/SelectTemplateCollectionItemTree/SelectTemplateCollectionItemTree';
import StudyAssociationInput from 'studies/StudyAssociationInput';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import {ButtonSize} from 'ui-library/buttons/Button';
import DateField from 'ui-library/inputs/DateField';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export function CreateEntryFromTemplateModalContentsV2(
  props: CreateEntryFromTemplateModalContentsProps
): JSX.Element {
  const showStudies = BenchlingConfig.STUDIES_ENABLE && props.studyAssociationInputProps;
  return (
    <>
      <Row>
        <Col sm={12}>
          <FormGroup dataTestAttrs={{component: 'CreateEntryFromTemplateModal', element: 'template'}}>
            <FieldLabel label="Template" isRequired={true} />
            <SelectTemplateCollectionItemTree
              collectibleType="TEMPLATE"
              filterTemplateIds={props.filterTemplateIds}
              showUnpublishedCollectibles={props.showUnpublishedCollectibles}
              collectibleId={props.templateId || ''}
              setCollectible={(template) => {
                if (template) {
                  props.changeTemplate(template);
                } else {
                  props.changeTemplate(null);
                }
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={7}>
          <FormGroup dataTestAttrs={{component: 'CreateEntryFromTemplateModal', element: 'name'}}>
            <FieldLabel label="Name" isRequired={true} />
            <input
              type="text"
              value={props.entryName}
              onChange={(e) => {
                props.setEntryName(clampEntryName(e.target.value));
              }}
            />
          </FormGroup>
        </Col>
        <Col sm={5}>
          <FormGroup dataTestAttrs={{component: 'CreateEntryFromTemplateModal', element: 'initialDay'}}>
            <FieldLabel label="Initial day" isRequired={true} />
            <DateField
              labelStyle={DateField.LABEL_STYLES.HIDDEN}
              value={props.initialDay}
              onChange={props.setInitialDay}
              placeholder=""
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm={showStudies ? 7 : 12}>
          <FormGroup dataTestAttrs={{component: 'CreateEntryFromTemplateModal', element: 'project'}}>
            <FieldLabel
              label={props.folderFieldLabel ?? DEFAULT_PROJECT_FOLDER_LABEL_TEXT}
              isRequired={true}
            />
            <FolderSelector
              buttonSize={ButtonSize.MEDIUM}
              enableRedesign={true}
              showNotebook={true}
              value={props.folderId}
              onChange={(e) => {
                props.setFolderId(e.target.value);
              }}
              unsetOnFetchFail={true}
            />
          </FormGroup>
        </Col>
        {showStudies && props.studyAssociationInputProps ? (
          <Col sm={5}>
            <FormGroup>
              <FieldLabel label="Studies" />
              <StudyAssociationInput {...props.studyAssociationInputProps} />
            </FormGroup>
          </Col>
        ) : null}
      </Row>
      <Row>
        <Col md={12} className="col-centered">
          <FieldLabel
            label="Entry schema"
            isRequired={BenchlingConfig.ELN_ENABLE_SCHEMA_REQUIRED_FOR_REVIEW}
          />
          {props.templateId ? renderTagTable(props) : <div>Please select a template first</div>}
        </Col>
      </Row>
    </>
  );
}
